import { SxProps, Theme } from '@mui/material';

import HeaderBackground from 'src/assets/images/backgrounds/HeaderBackground.jpg';

import { PageHeaderVariant } from '../index';

interface PageHeaderVariantStyles {
    parentContainerStyles: SxProps<Theme>;
    headingStyles: SxProps<Theme>;
    subHeadingStyles: SxProps<Theme>;
}

export const getStylesByPageHeaderVariant = (
    variant: PageHeaderVariant,
    borderColor: string
): PageHeaderVariantStyles => {
    let styles: PageHeaderVariantStyles = {
        parentContainerStyles: {
            height: '116px',
            border: `1px solid ${borderColor}`,
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
            borderRadius: '16px',
            padding: '8px 24px',
            display: 'flex',
            justifyContent: {
                xs: 'center',
                sm: 'center',
                md: 'space-between',
                lg: 'space-between',
                xl: 'space-between',
            },
            alignItems: 'center',
            flexDirection: {
                xs: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
            },
        },
        headingStyles: {
            fontSize: '24px',
            fontWeight: '700',
            lineHeight: '34px',
            color: '#1d1d1b',
        },
        subHeadingStyles: {},
    };

    if (variant === PageHeaderVariant.DASHBOARD) {
        styles = {
            parentContainerStyles: {
                ...styles.parentContainerStyles,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: '16px',
                backgroundImage: `url(${HeaderBackground})`,
            },
            headingStyles: {
                ...styles.headingStyles,
                fontSize: '24px',
                lineHeight: '34px',
                fontWeight: '700',
                color: '#1D1D1B',
            },
            subHeadingStyles: {
                ...styles.subHeadingStyles,
                fontSize: '21px',
                fontWeight: '400',
                lineHeight: '30px',
                color: '#F39E4E',
            },
        };
    }

    return styles;
};
